import { render, staticRenderFns } from "./safeguard.vue?vue&type=template&id=206ed9e2&scoped=true"
import script from "./safeguard.vue?vue&type=script&lang=js"
export * from "./safeguard.vue?vue&type=script&lang=js"
import style0 from "./safeguard.vue?vue&type=style&index=0&id=206ed9e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206ed9e2",
  null
  
)

export default component.exports